export var FirestoreSnapperType;
(function (FirestoreSnapperType) {
    FirestoreSnapperType["Query"] = "query";
    FirestoreSnapperType["Document"] = "document";
})(FirestoreSnapperType || (FirestoreSnapperType = {}));
